<template>
  <div class="info-block" :class="{ 'no-top-padding': noTopPadding }">
    <h2 ref="title" class="info-block__title">{{ title }}</h2>
    <div class="info-block__text-wrapper">
      <Article v-if="copy" class="info-block__text" :text-content="copy" />
    </div>
    <div class="info-block__cards-wrapper">
      <InfoCard
        v-for="(item, index) in iconText"
        :key="index"
        ref="info-card"
        class="info-block__info-card"
        :icon="item.icon.name"
        :icon-color="item.iconColor"
        :title="item.title"
        :subtitle="item.subtitle"
        :text="item.text"
      />
    </div>
    <div class="info-block__button-wrapper">
      <NavLink
        ref="button"
        v-track="buttonProps.tracking"
        class="info-block__button"
        v-bind="buttonProps"
        :link="buttonProps.link ? buttonProps.link[0].link : buttonProps.to"
        :routing-component="AppButton"
        >{{ buttonProps.label }}</NavLink
      >
    </div>
  </div>
</template>

<script>
import InfoCard from "./InfoCard.vue"
import AppButton from "./AppButton.vue"
import Article from "./Article"
import NavLink from "./NavLink.vue"
import buttonProps from "../helpers/buttonProps"

import markRaw from "../helpers/markRaw"

export default {
  components: {
    InfoCard,
    NavLink,
    Article
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    copy: {
      type: Object,
      default: null
    },
    article: {
      type: Object,
      default: null
    },
    iconText: {
      type: Array,
      default: null
    },
    button: {
      type: Array,
      default: null
    },
    userSignedIn: {
      type: Boolean,
      default: false
    },
    noTopPadding: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AppButton: markRaw(AppButton)
    }
  },
  computed: {
    buttonProps() {
      return buttonProps(this.button, this.userSignedIn)
    }
  }
}
</script>

<style scoped lang="scss">
.info-block {
  width: 100%;
  padding: $space-14 $space-2;
  &__title {
    text-align: center;
    margin-bottom: $space-8;
  }

  &__text-wrapper {
    display: flex;
    justify-content: center;
  }

  &__text {
    max-width: 400px;
    padding: 0 $space-2;
    @include md {
      max-width: 50%;
    }
  }

  &__cards-wrapper {
    display: flex;
    align-content: center;
    flex-direction: column;
    gap: $space-5;
    flex-wrap: wrap;

    margin-bottom: $space-14;

    @include lg {
      justify-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      margin-top: $space-8;
    }
  }

  &__info-card {
    max-width: 410px;
  }

  &__button-wrapper {
    display: flex;
    width: 100%;
    justify-content: center;
  }
}

.no-top-padding {
  padding-top: 0;
}
</style>
